import Constants from "utils/Constants";
import StrUtils from "utils/StrUtils";
import IconCard from "../IconCard";

const defaultActions = Constants.WORKFLOW_ACTIONS;

const SelectActionSection = ({ action, setAction, actions }) => {
  const selectAction = (newAction) => () => {
    if (action?.Type === newAction?.Type) {
      return setAction(null);
    }

    setAction({
      ...newAction,
      Name: "",
      Description: "",
      id: StrUtils.uuidv4(),
    });
  };

  return Object.keys(defaultActions).map((key) => {
    // The action.
    const a = defaultActions[key];

    if (a?.Hide(actions)) return null;

    return (
      <IconCard
        key={key}
        icon={a?.Icon}
        vectorIcon={a?.VectorIcon}
        name={a?.ActionName}
        description={a?.ActionDescription}
        isSelected={a?.Type === action?.Type}
        onClick={selectAction(a)}
        css="my-2"
      />
    );
  });
};

export default SelectActionSection;
